<template>
  <LockedInstitutionField v-if="locked" :name="lockedInstitutionName" />

  <RegistrationInstitutionPicker
    v-else
    :model-value="modelValue"
    :registration-user-type="registrationUserType"
    @update:model-value="(value) => emit('update:modelValue', value)"
  />
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import LockedInstitutionField from "@/modules/institutions/components/LockedInstitutionField.vue";
import RegistrationInstitutionPicker from "@/modules/institutions/components/RegistrationInstitutionPicker.vue";

const props = withDefaults(
  defineProps<{
    modelValue: number | undefined | null;
    registrationUserType: "parent" | "institution_worker";
    lockedInstitutionId?: number | null;
    lockedInstitutionName?: string | null;
  }>(),
  {
    lockedInstitutionId: null,
    lockedInstitutionName: null,
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: number | undefined];
}>();

const locked = computed(() => !!props.lockedInstitutionId);

// A locked institution is resolved entirely by the caller (dedicated link or a manually
// entered code already confirmed against /register/modes) - this component only displays it.
watch(
  () => props.lockedInstitutionId,
  (institutionId) => {
    if (institutionId) {
      emit("update:modelValue", institutionId);
    }
  },
  { immediate: true },
);
</script>
